import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "./Menu";
import logo from "../../assets/images/portl-admin-logo.png";
import { Constants } from "./Constants";
import { RoutesUrl } from "./RoutesUrl";
import { deleteConfirmBox } from "./Functions/deleteConfirmBox";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/Actions/Auth";
import { useSelector } from "react-redux";

const Sidebar = (props) => {
  const [isSidebarMini, setIsSidebarMini] = useState(false);
  const [menuData, setMenuData] = useState([...Menu]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const roleType = localStorage.getItem(Constants.roleType);
  const { permissionsArr } = useSelector((state) => state.Auth);
  const {
    permission: {
      DASHBOARD_VIEW,
      BADGE_VIEW,
      BODY_PART_VIEW,
      EXER_CATEGORY_VIEW,
      CHALLENGE_VIEW,
      CUSTOMER_VIEW,
      CMS_VIEW,
      EQUIPMENT_VIEW,
      EXERCISE_VIEW,
      EXER_GOAL_VIEW,
      GOAL_VIEW,
      MECHANICS_VIEW,
      NOTIFI_VIEW,
      PROGRAMME_VIEW,
      REPORT_VIEW,
      ROLE_MGT_VIEW,
      TUTORIAL_VIEW,
      WORKOUT_VIEW,
    },
  } = Constants;

  // on click of main tab that has no children
  const openChildren = (id) => {
    const otherTabs = document.getElementsByClassName("has-children");
    if (otherTabs) {
      for (let i = 0; i < otherTabs.length; i++) {
        if (otherTabs[i].id !== id) {
          otherTabs[i].className = otherTabs[i].className.replace(" show", "");
          if (otherTabs[i].parentElement.children.length > 1) {
            otherTabs[i].parentElement.children?.[0].setAttribute(
              "aria-expanded",
              "false"
            );
          }
        }
      }
    }
    const menutab = document.getElementById(id);
    if (menutab) {
      if (menutab.classList.contains("show")) {
        menutab.classList.remove("show");
        if (menutab.parentElement.children.length > 1) {
          menutab.parentElement.children?.[0].setAttribute(
            "aria-expanded",
            "false"
          );
        }
      } else {
        menutab.classList.add("show");
        if (menutab.parentElement.children.length > 1) {
          menutab.parentElement.children?.[0].setAttribute(
            "aria-expanded",
            "true"
          );
        }
      }
    }
  };

  // Main side tab that has 1 or more children
  const openChildren1 = (id) => {
    const otherTabs = document.getElementsByClassName("has-children");
    if (otherTabs) {
      for (let i = 0; i < otherTabs.length; i++) {
        otherTabs[i].className = otherTabs[i].className.replace(" show", "");
      }
    }
    const menutab = document.getElementById(id);
    if (menutab) {
      menutab.classList.add("show");
      if (menutab.parentElement.children.length > 1) {
        menutab.parentElement.children?.[0].setAttribute(
          "aria-expanded",
          "true"
        );
      }
    }
  };

  const GotoChangeMenu = () => {
    props.history.push("dashboard");
    setMenuData([...Menu]);
  };

  // Signout API
  const signOut = () => {
    deleteConfirmBox({ text: Constants.youWantToSignOut }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout()).then((response) => {
          if (response?.data === 200) {
            navigate(RoutesUrl.signIn);
            localStorage.clear();
          }
        });
      }
    });
  };

  const { activekey } = props;

  // Whether user role has permission or not
  const checkPermission = (permissionKey, valueToCheck = true) => {
    return permissionsArr?.[permissionKey] !== valueToCheck;
  };

  // Sidebar tabs cases for view
  const shouldHideMenuItem = (d) => {
    switch (d.name) {
      case Constants.dashboard:
        return checkPermission(DASHBOARD_VIEW);
      case Constants.badges:
        return checkPermission(BADGE_VIEW);
      case Constants.bodyParts:
        return checkPermission(BODY_PART_VIEW);
      case Constants.exerciseCategory:
        return checkPermission(EXER_CATEGORY_VIEW);
      case Constants.challenge:
        return checkPermission(CHALLENGE_VIEW);
      case Constants.customer:
        return checkPermission(CUSTOMER_VIEW);
      case Constants.cms:
        return checkPermission(CMS_VIEW);
      case Constants.equipment:
        return checkPermission(EQUIPMENT_VIEW);
      case Constants.exercise:
        return checkPermission(EXERCISE_VIEW);
      case Constants.exerciseGoal:
        return checkPermission(EXER_GOAL_VIEW);
      case Constants.goals:
        return checkPermission(GOAL_VIEW);
      case Constants.mechanics:
        return checkPermission(MECHANICS_VIEW);
      case Constants.notification:
        return checkPermission(NOTIFI_VIEW);
      case Constants.programme:
        return checkPermission(PROGRAMME_VIEW);
      case Constants.reports:
        return checkPermission(REPORT_VIEW);
      case Constants.roleMgt:
        return checkPermission(ROLE_MGT_VIEW);
      case Constants.tutorial:
        return checkPermission(TUTORIAL_VIEW);
      case Constants.workout:
        return checkPermission(WORKOUT_VIEW);
      default:
        return false;
    }
  };

  return (
    <div
      id="mainsidemenu"
      className={`sidebar py-4 py-md-4 me-0 ${
        isSidebarMini ? "sidebar-mini" : ""
      }`}
      style={{ overflow: "scroll" }}
    >
      <div className="d-flex flex-column h-100 d-block">
        {!isSidebarMini && (
          <img
            onClick={() => navigate(RoutesUrl.dashboard)}
            src={logo}
            className="mb-0 brand-icon cursor-pointer logo-sidebar-img  d-block"
            alt="logo"
          />
        )}
        <ul className="menu-list flex-grow-1">
          {menuData.map((d, i) => {
            if (d.isToggled) {
              return (
                <li key={"shsdg" + i}>
                  <a
                    className={"m-link"}
                    href="#!"
                    onClick={(e) => {
                      const sidebar = document.getElementById("mainsidemenu");
                      sidebar?.classList?.remove("open");
                      e.preventDefault();
                      GotoChangeMenu(d.name);
                    }}
                  >
                    <i className={d.iconClass}></i>
                    <span>{d.name}</span>
                  </a>
                </li>
              );
            }
            // Check permission for tabs
            if (roleType !== Constants.adminKey && shouldHideMenuItem(d)) {
              return null;
            }
            // If tab has 0 sub tabs
            if (d.children.length === 0) {
              return (
                <li key={"dsfshsdg" + i} className=" collapsed">
                  <Link
                    to={
                      d.name !== Constants.signout
                        ? process.env.PUBLIC_URL + "/" + d.routerLink[0]
                        : location
                    }
                    onClick={
                      d.name === Constants.signout ? () => signOut() : ""
                    }
                    className={`m-link sidebar-link ${
                      activekey.includes(d.routerLink?.[0]) ? "active" : ""
                    }`}
                  >
                    <i className={d.iconClass}></i>
                    <span>{d.name}</span>
                    <span className="ms-auto text-end fs-5"></span>
                  </Link>
                </li>
              );
            }
            // If tab has sub tabs
            return (
              <li key={"shsdg" + i} className="collapsed">
                <a
                  className={`m-link  ${
                    d.children.filter(
                      (d) => "/" + d.routerLink[0] === activekey
                    ).length > 0
                      ? "active"
                      : ""
                  }`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    openChildren("menu-Pages" + i);
                  }}
                >
                  <i className={d.iconClass}></i>
                  <span>{d.name}</span>
                  <span className="arrow icofont-dotted-down ms-auto text-end fs-5"></span>
                </a>
                {d.children.length > 0 ? (
                  <ul
                    className="sub-menu collapse has-children"
                    id={"menu-Pages" + i}
                  >
                    {d.children.map((data, ind) => {
                      if (d.children.length > 0) {
                        if (activekey === "/" + data.routerLink?.[0]) {
                          setTimeout(() => {
                            const sidebar =
                              document.getElementById("mainsidemenu");
                            sidebar?.classList?.remove("open");
                            openChildren1("menu-Pages" + i);
                          }, 500);
                        }
                      }
                      return (
                        <li key={"jfdgj" + ind}>
                          <Link
                            className={
                              activekey === "/" + data.routerLink?.[0]
                                ? "ms-link active sidebar-link"
                                : "ms-link sidebar-link"
                            }
                            to={
                              process.env.PUBLIC_URL +
                              "/" +
                              data.routerLink?.[0]
                            }
                          >
                            <span> {` • ${data.name} `}</span>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                ) : null}
              </li>
            );
          })}
        </ul>
        <button
          type="button"
          className="btn btn-link sidebar-mini-btn text-light"
          onClick={() => {
            setIsSidebarMini(!isSidebarMini);
          }}
        >
          <span className="ms-2">
            <i className="icofont-bubble-right"></i>
          </span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
